import { type GriffelStyle, makeStyles, tokens } from '@fluentui/react-components';
import { px } from '@this/app-shared/dist/tools/styles.js';

const gradient: GriffelStyle = {
    content: '""',
    position: 'absolute',
    height: tokens.spacingVerticalXXL,
    left: px(0),
    right: `calc(${tokens.spacingVerticalL} + ${tokens.spacingVerticalXXS})`,
    pointerEvents: 'none',
    zIndex: tokens.zIndexOverlay,
};

export const useStyles = makeStyles({
    containerContainer: {
        display: 'grid',
        gridTemplateAreas: `
            'container'
        `,
        gridTemplateColumns: '1fr',
        gridTemplateRows: '1fr',
        overflow: 'hidden',
    },
    gradientContainer: {
        gridArea: 'container',
        position: 'relative',
        pointerEvents: 'none',
        userSelect: 'none',
    },
    gradientTop: {
        ...gradient,
        top: px(0),
    },
    gradientBottom: {
        ...gradient,
        bottom: px(0),
    },
    content: {
        gridArea: 'container',
        display: 'grid',
        padding: tokens.spacingVerticalXXL,
        overflowY: 'auto',
        containerType: 'inline-size',
    },
    contentWithoutPadding: {
        padding: px(0),
    },
});
